export default __webpack_public_path__ + "static/media/logo-white.81f68eae.svg";